import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { CardListItem, CardListItemProps } from 'record-it-components/cardList/CardListItem/CardListItem';
import { CardListItemIconButton } from 'record-it-components/cardList/CardListItemIconButton/CardListItemIconButton';
import { CardListItemIconLink } from 'record-it-components/cardList/CardListItemIconLink/CardListItemIconLink';
import { CardListItemTitle } from 'record-it-components/cardList/CardListItemTitle/CardListItemTitle';
import { useModalOpened } from 'record-it-components/hooks/useModalOpened/useModalOpened';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { TimeTrackingActivity } from '../../../classes/entities/TimeTrackingActivity/timeTrackingActivityTypes';
import { iconConfigurations } from '../../../classes/icon/iconConfigurations';
import { RoutePaths } from '../../../classes/RoutePaths/RoutePaths';
import { useTimeTrackingActivityDeleteHandler } from '../../../hooks/entity/deleteHandler/useTimeTrackingActivityDeleteHandler';
import { EditTimeTrackingActivityDialog } from '../EditTimeTrackingActivityDialog/EditTimeTrackingActivityDialog';
export type TimeTrackingActivityListItemProps = PropsWithoutChildren<CardListItemProps> & {
  readonly timeTrackingActivity: TimeTrackingActivity;
};
export const TimeTrackingActivityListItem = React.memo<TimeTrackingActivityListItemProps>(props => {
  const $ = _c(31);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props,
      ignoreChildren: true
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let ref;
  let remainingProps;
  let timeTrackingActivity;
  if ($[2] !== t0) {
    ({
      timeTrackingActivity,
      ref,
      ...remainingProps
    } = t0);
    $[2] = t0;
    $[3] = ref;
    $[4] = remainingProps;
    $[5] = timeTrackingActivity;
  } else {
    ref = $[3];
    remainingProps = $[4];
    timeTrackingActivity = $[5];
  }
  let t1;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      closeOnBackDropClick: true
    };
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const {
    open: openEditDialog,
    close: closeEditDialog,
    modalProps
  } = useModalOpened(t1);
  const handleDeleteClick = useTimeTrackingActivityDeleteHandler(timeTrackingActivity);
  let t2;
  if ($[7] !== timeTrackingActivity.name) {
    t2 = <CardListItemTitle data-testid="TimeTrackingActivityListItem.Name">{timeTrackingActivity.name}</CardListItemTitle>;
    $[7] = timeTrackingActivity.name;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== handleDeleteClick) {
    t3 = <CardListItemIconButton {...iconConfigurations.prefixed.listItem.deleteIcon} onClick={handleDeleteClick} data-testid="TimeTrackingActivityListItem.DeleteButton" />;
    $[9] = handleDeleteClick;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== openEditDialog) {
    t4 = <CardListItemIconButton {...iconConfigurations.prefixed.listItem.editInDialogIcon} onClick={openEditDialog} />;
    $[11] = openEditDialog;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== timeTrackingActivity.compilationId || $[14] !== timeTrackingActivity.id || $[15] !== timeTrackingActivity.parentActivityId) {
    t5 = !timeTrackingActivity.parentActivityId ? <CardListItemIconLink {...iconConfigurations.prefixed.listItem.enterListItem} to={RoutePaths.adminTimeTrackingActivities(timeTrackingActivity.compilationId, timeTrackingActivity.id)} data-testid="TimeTrackingActivityListItem.NavigateToSubEntities" /> : null;
    $[13] = timeTrackingActivity.compilationId;
    $[14] = timeTrackingActivity.id;
    $[15] = timeTrackingActivity.parentActivityId;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== ref || $[18] !== remainingProps || $[19] !== t2 || $[20] !== t3 || $[21] !== t4 || $[22] !== t5) {
    t6 = <CardListItem ref={ref} {...remainingProps}>{t2}{t3}{t4}{t5}</CardListItem>;
    $[17] = ref;
    $[18] = remainingProps;
    $[19] = t2;
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  let t7;
  if ($[24] !== closeEditDialog || $[25] !== modalProps || $[26] !== timeTrackingActivity) {
    t7 = <EditTimeTrackingActivityDialog {...modalProps} timeTrackingActivity={timeTrackingActivity} onAccept={closeEditDialog} />;
    $[24] = closeEditDialog;
    $[25] = modalProps;
    $[26] = timeTrackingActivity;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  let t8;
  if ($[28] !== t6 || $[29] !== t7) {
    t8 = <>{t6}{t7}</>;
    $[28] = t6;
    $[29] = t7;
    $[30] = t8;
  } else {
    t8 = $[30];
  }
  return t8;
});